<template>
  <div class="loading_spinner--container" role="progressbar" aria-valuetext="Loading calendar"
       aria-busy="true">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "LoadingSpinner",
})
</script>

<style scoped>
.loading_spinner--container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  transition: opacity 250ms ease-in, visibility 1ms linear 250ms;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
}

.loading_spinner--container .circular {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transform-origin: center center;
  animation: loader-rotate 2000ms linear infinite;
}

.loading_spinner--container circle {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: loader-dash 1500ms ease-in-out infinite, loader-color 6000ms ease-in-out infinite;
}

@keyframes loader-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loader-dash {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes loader-dash-small {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -23px;
  }
  100% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -93px;
  }
}

@keyframes loader-color {
  100%,
  from {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%,
  90% {
    stroke: #ffa700;
  }
}
</style>